(ns app.youtube-posting.register
  "UI register entries for the YouTube Shorts posting slice."
  (:require [app.youtube-posting.page :as page]))

(def register
  [page/page])
